import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Button } from "reactstrap";
import TableNameField from "./TableNameField";


const TableNamesFields = (props) => {
  const { isNumeric } = props;
  const { control } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "tableNames",
  }); 

  const defaultTableNameData = {
    asset_name: "",
    contractedCap: "",
    thing_name: "",
    limitedRate: "",
    batMSB: "",
    batCap: "",
    chargeRate: "",
  }

  return (
    <div>
      {fields.map((field, index) => (
        <TableNameField
          key={field.id}
          index={index}
          isNumeric={isNumeric}
          onDelete={() => remove(index)}
          numOfFields={fields.length}
        />
      ))}

      <Button 
        className="mr-3 btn-rounded" 
        type="button" 
        color="primary"
        onClick={() => append(defaultTableNameData)}
      >
        Add
      </Button>
    </div>
  );
}

export default TableNamesFields;